import React, { useState,useContext } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../authcontext/authContext";
import "./OtpPage.css"; // Importing CSS for styling

const OtpPage = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isVerified, setIsVerified] = useState(false);
   const [err, setErr] = useState(null);
   const [ettor, setEttor] = useState(false)
  


  const navigate = useNavigate()
   const { passrest } = useContext(AuthContext);

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Automatically focus the next input
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleVerify = async (e) => {
    const otpValue = otp.join("");
    // Simulate OTP verification (replace with actual API call)
    if (otpValue.length > 0) {
        e.preventDefault();
    try {
      await passrest({otp:otpValue});
      setIsVerified(true);
      navigate("/passchange")
    } catch (error) {
      setErr(error.response.data);
      setEttor(!ettor)
    }

    } else {
      alert("Invalid OTP. Please try again.");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="otp-container"
    >
      <h1 className="otp-title"> Input Otp sent to registered Email to verify User</h1>
      {!isVerified ? (
        <div className="otp-box">
          <div className="otp-input-container">
            {otp.map((value, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                maxLength="1"
                value={value}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && !value && index > 0) {
                    document.getElementById(`otp-input-${index - 1}`).focus();
                  }
                }}
                className="otp-input"
              />
            ))}
          </div>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="verify-button"
            onClick={handleVerify}
          >
            Verify OTP
          </motion.button>
          {ettor ? <div> {err.error} </div> : null}
        </div>
      ) : (
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="success-message"
        >
           
          <h2>Email Verified Successfully! 🎉</h2>
        </motion.div>
      )}
    </motion.div>
  );
};

export default OtpPage;